const CURATED_BY_MAESTRO = {
  en: 'Curated by Maestro',
  es: 'Seleccionado por Maestro',
  fr: 'Sélection Maestro',
  de: 'Kuratiert von Maestro',
  it: 'Selezionato da Maestro',
  pt: 'Selecionado pela Maestro',
  ja: 'Maestro厳選',
  ko: 'Maestro 큐레이션',
  zh: 'Maestro 精选',
  nl: 'Samengesteld door Maestro', sv: 'Utvalt av Maestro',
};

export function curatedByMaestroLabel(lang) {
  return CURATED_BY_MAESTRO[lang] || CURATED_BY_MAESTRO.en;
}
